import React from "react";
import {startOfDay} from "date-fns";

import StyledToggleButtonGroup from "../../../components/StyledToggleButtonGroup";
import {isValidDateObject} from "../../../services/date/validators";
import {INDETERMINATE} from "./usePriceSummarizer";
import PriceTag from "./PriceTag";

import ToggleButton from "@mui/material/ToggleButton";
import PersonIcon from "@mui/icons-material/Person";
import GroupsIcon from "@mui/icons-material/Groups";
import {Checkbox, Divider} from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {DatePicker} from "@mui/x-date-pickers";


const TabBasePrice = (props) => {
    const {
        formik,
        basePeople,
        ratesViewMode,
        onRatesViewModeChange,
        dateDisabled,
        height=475
    } = props;

    return <Stack direction="column" spacing={4} mt={2} height={height}>
        <Typography>
            Modifica il prezzo base per il periodo selezionato. Seleziona
            i pannelli per modificare le condizioni e i prezzi per persona.
        </Typography>

        <Stack direction="row" spacing={2}>
            <DatePicker value={formik.values.dateFrom}
                        onChange={date => formik.setFieldValue("dateFrom", startOfDay(date))}
                        disablePast
                        label="Periodo da"
                        closeOnSelect
                        disableHighlightToday
                        showDaysOutsideCurrentMonth
                        disabled={dateDisabled}
                        slotProps={{
                            textField: {
                                fullWidth: true,
                                required: true,
                                error: Boolean(formik.touched.dateFrom) && Boolean(formik.errors.dateFrom),
                                helperText: formik.touched.dateFrom && formik.errors.dateFrom
                            }
                        }}/>

            <DatePicker value={formik.values.dateTo}
                        onChange={date => formik.setFieldValue("dateTo", startOfDay(date))}
                        disablePast
                        minDate={formik.values.dateFrom}
                        defaultCalendarMonth={isValidDateObject(formik.values.dateFrom) ? formik.values.dateFrom : undefined}
                        label="Periodo a"
                        closeOnSelect
                        disableHighlightToday
                        showDaysOutsideCurrentMonth
                        disabled={dateDisabled}
                        slotProps={{
                            textField: {
                                fullWidth: true,
                                required: true,
                                error: Boolean(formik.touched.dateTo) && Boolean(formik.errors.dateTo),
                                helperText: formik.touched.dateTo && formik.errors.dateTo
                            }
                        }}/>
        </Stack>

        <PriceTag formik={formik} ratesViewMode={ratesViewMode} people={basePeople}/>

        <Box textAlign="right">
            <StyledToggleButtonGroup
                value={ratesViewMode}
                exclusive
                onChange={onRatesViewModeChange}
                aria-label="form rates view mode"
                size="small"
                color="primary">
                <ToggleButton value="person" aria-label="person">
                    <PersonIcon fontSize="small"/> / notte
                </ToggleButton>
                <ToggleButton value="people" aria-label="people">
                    <GroupsIcon fontSize="small"/> / notte
                </ToggleButton>
            </StyledToggleButtonGroup>
        </Box>

        <Divider sx={{flexGrow: 1}}/>

        <FormControlLabel
            control={
                <Checkbox name="enabled"
                          checked={formik.values.enabled === INDETERMINATE ? false : formik.values.enabled === true}
                          indeterminate={formik.values.enabled === INDETERMINATE}
                          onChange={(e) => {
                              // cannot use formik.handleChange because it does not work as expected with indeterminate
                              formik.setFieldValue("enabled", e.target.checked)
                          }}
                          color="primary"
                />
            }
            label="Struttura prenotabile con questa tariffa"/>
    </Stack>;
}


export default TabBasePrice;